import getOrderedLinks from './getOrderedLinks'

export default function (content, links, sourcesIds) {
  let result = {}
  sourcesIds.forEach((sourceId) => {
    result[sourceId] = null
  })
  const orderedLinks = getOrderedLinks(content)
  let index = 0
  orderedLinks.forEach((linkId) => {
    if (links[linkId].sources) {
      links[linkId].sources.forEach((sourceId) => {
        if (result[sourceId]) {
          return
        }
        result[sourceId] = ++index
      })
    }
  })
  return result
}


// WEBPACK FOOTER //
// ./src/shared/getOrderedSources.js